export const FristenGrund = {
  ARBEITSVERTRAG_ENDE: 'ARBEITSVERTRAG_ENDE',
  PROBEZEIT_ENDE: 'PROBEZEIT_ENDE',
  ARBEITSERLAUBNIS_ENDE: 'ARBEITSERLAUBNIS_ENDE',
  AUFENTHALTSERLAUBNIS_ENDE: 'AUFENTHALTSERLAUBNIS_ENDE',
  SEMESTERBESCHEINIGUNG_ENDE: 'SEMESTERBESCHEINIGUNG_ENDE',
  ANDERER: 'ANDERER',
} as const;

export type FristenGrund = (typeof FristenGrund)[keyof typeof FristenGrund];
